
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-gray-900/95 backdrop-blur-sm shadow-lg' 
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 py-4">
        <div className="flex items-center justify-between">
          <a 
            href="https://www.avertnetworkservices.com" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="flex-shrink-0 cursor-pointer"
          >
            <img 
              src="https://static.readdy.ai/image/9041450fc173856249e31fa6f138bbf1/f551299d65d78b85b477c46b5802fd7d.png" 
              alt="Healthcare IT Partners" 
              className="h-12 w-auto"
            />
          </a>

          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className={`${isScrolled ? 'text-white' : 'text-white'} hover:text-[#e10708] transition-colors font-medium whitespace-nowrap cursor-pointer`}>
              Home
            </Link>
            <Link to="/partners" className={`${isScrolled ? 'text-white' : 'text-white'} hover:text-[#e10708] transition-colors font-medium whitespace-nowrap cursor-pointer`}>
              Partners
            </Link>
            <Link to="/resources" className={`${isScrolled ? 'text-white' : 'text-white'} hover:text-[#e10708] transition-colors font-medium whitespace-nowrap cursor-pointer`}>
              Resources
            </Link>
            <Link to="/cyber-insurance-checklist" className={`${isScrolled ? 'text-white' : 'text-white'} hover:text-[#e10708] transition-colors font-medium whitespace-nowrap cursor-pointer`}>
              Cyber Insurance
            </Link>
            <Link to="/contact" className={`${isScrolled ? 'text-white' : 'text-white'} hover:text-[#e10708] transition-colors font-medium whitespace-nowrap cursor-pointer`}>
              Contact
            </Link>
            <Link
              to="/contact"
              className="bg-[#e10708] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#c00607] transition-all duration-300 shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer"
            >
              Get Started
            </Link>
          </div>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-white hover:text-[#e10708] transition-colors cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>

          {isMenuOpen && (
            <div className="md:hidden absolute top-full left-0 right-0 bg-gray-900 shadow-xl border-t border-gray-700 py-6 px-6">
              <div className="flex flex-col gap-4">
                <Link to="/" className="text-white hover:text-[#e10708] transition-colors font-medium py-2 whitespace-nowrap cursor-pointer">
                  Home
                </Link>
                <Link to="/partners" className="text-white hover:text-[#e10708] transition-colors font-medium py-2 whitespace-nowrap cursor-pointer">
                  Partners
                </Link>
                <Link to="/resources" className="text-white hover:text-[#e10708] transition-colors font-medium py-2 whitespace-nowrap cursor-pointer">
                  Resources
                </Link>
                <Link to="/cyber-insurance-checklist" className="text-white hover:text-[#e10708] transition-colors font-medium py-2 whitespace-nowrap cursor-pointer">
                  Cyber Insurance
                </Link>
                <Link to="/contact" className="text-white hover:text-[#e10708] transition-colors font-medium py-2 whitespace-nowrap cursor-pointer">
                  Contact
                </Link>
                <Link
                  to="/contact"
                  className="bg-[#e10708] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#c00607] transition-all duration-300 text-center whitespace-nowrap cursor-pointer"
                >
                  Get Started
                </Link>
              </div>
            </div>
          )}

          <div className="hidden lg:flex items-center gap-6">
            <a 
              href="tel:+18552837848" 
              className="flex items-center gap-2 text-white hover:text-[#e10708] transition-colors cursor-pointer"
            >
              <i className="ri-phone-line text-lg"></i>
              <span className="text-sm font-medium whitespace-nowrap">(855) 283-7848</span>
            </a>
            
            <a 
              href="mailto:protectus@healthcareitpartners.com" 
              className="flex items-center gap-2 text-white hover:text-[#e10708] transition-colors cursor-pointer"
            >
              <i className="ri-mail-line text-lg"></i>
              <span className="text-sm font-medium whitespace-nowrap">protectus@healthcareitpartners.com</span>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}
